import { Products } from '../app/products';

export const PRODS:Products[]=[
    {    
        id: 1,
        name:"Beats EP",
        price:15550,
        description:"The preferred choice of a vast range of acclaimed DJs. Punchy, bass-focused sound and high isolation. Sturdy headband and on-ear cushions suitable for live performance",
        stock:5,
        imageurl:["assets/img/products/red.png","assets/img/products/blue.png","assets/img/products/black.png"],
        category:"ELECTRONICS"
    },

    {    
        id: 2,
        name:"4K UHD TV ",
        price:155500,
        description:"With a perfect combination of stunning 4K picture quality and impressive sound quality, this 139-cm (55) Ultra HD 4K LED Smart TV from Sony is an ideal choice for anyone who loves to watch movies or play games.",
        stock:5,
        imageurl:["assets/img/products/tv1.jpeg","assets/img/products/tv2.jpeg","assets/img/products/tv3.jpeg"],
        category:"TVAPPLIANCES"
    },

    {    
        id: 11,
        name:"Apple Watch Series 3 GPS  ",
        price:25000,
        description:"42 mm Space Grey Aluminium Case with Grey Sport Band (Grey Strap Regular)",
        stock:5,
        imageurl:["assets/img/apple2.jpg","assets/img/products/apple2.jpeg","assets/img/products/apple1.jpeg"],
        category:"ELECTRONICS"
    },
    

    
    {    
        id: 3,
        name:"Hp Au-111-tx",
        price:65000,
        description:"Its integrated with most powerfull Cpu and Hardware.",
        stock:5,
        imageurl:["assets/img/laptop-1.jpg","assets/img/products/laptop2.jpeg","assets/img/products/laptop1.jpeg"],
        category:"ELECTRONICS"
    },

    
    

    {
        id: 5,
        name:"Wrangler Men's Shirt",
        price:1500,
        description:"Tony Y/D check Shirt",
        stock:5,
        imageurl:["assets/img/products/mshirt1.jpeg","assets/img/products/mshirt1_1.jpeg","assets/img/products/mshirt2_2.jpeg"],
        category:"CLOTHINGM"
    },


    

    {
        id: 7,
        name:"Leather Sofa 1 Seater",
        price:26550,
        description:"One of the most comfortable Sofa in affordable price. ",
        stock:5,
        imageurl:["assets/img/products/sofa1.jpeg","assets/img/products/sofa2.jpeg","assets/img/products/sofa1.jpeg"],
        category:"FURNITURE"
    },
    {
        id: 6,
        name:"Maniac Checkered Men's Round Neck Tshirt",
        price:450,
        description:"Its a full sleeve Mens Shirt.",
        stock:5,
        imageurl:["assets/img/products/mshirt2.jpeg","assets/img/products/mshirt2-1.jpeg","assets/img/products/mshirt2-2.jpeg"],
        category:"CLOTHINGM"
    },
    {
        id: 8,
        name:"Shrey Cricket Helmet",
        price:1550,
        description:"Its very Lightweight and strong helmet.",
        stock:5,
        imageurl:["assets/img/products/cricket1.jpeg","assets/img/products/cricket2.jpeg","assets/img/products/cricket3.jpeg"],
        category:"SPORTS"
    },
    {
        id: 9,
        name:"Titan Watch Model 1",
        price:1800,
        description:"Titan Company Limited (earlier known as Titan Industries Limited) is an Indian luxury goods company. It is a joint venture between the TATA Group.",
        stock:5,
        imageurl:["assets/img/products/watch1.jpeg","assets/img/products/watch_1_1.jpeg","assets/img/products/watch_1_2.jpeg"],
        category:"WATCH"
    },

    


    
    {
        id: 13,
        name:"WallStone Designer Dress",
        price:5000,
        description:"WallStone Designer Dress",
        stock:5,
        imageurl:["assets/img/products/dress.jpg"],
        category:"CLOTHINGF"
    },

    {
        id: 14,
        name:"'So Far So Good' long sleeve t-shirt",
        price:2000,
        description:"FROM OUR AUTUMN/WINTER 2018 COLLECTION, THE ‘SO FAR SO GOOD’ LONG SLEEVE IS A REMINDER THAT GOOD THINGS DON’T COME OVER NIGHT.",
        stock:5,
        imageurl:["assets/img/products/clothingg.jpg"],
        category:"CLOTHINGF"
    },

    
    
    {
        id: 15,
        name:"Crafted MacBook Air",
        price:67900,
        description:"Most Powerful Cpu of Apple with 512GB od SSD.",
        stock:10,
        imageurl:["assets/img/products/Macbook_Air_wood.png"],
        category:"ELECTRONICS"
    },

    {
        id: 10,
        name:"Titan Watch Model 2",
        price:2000,
        description:"Titan Company Limited (earlier known as Titan Industries Limited) is an Indian luxury goods company. It is a joint venture between the TATA Group.",
        stock:5,
        imageurl:["assets/img/products/watch2.jpeg","assets/img/products/titan_2_1.jpeg","assets/img/products/titan_2_2.jpeg"],
        category:"WATCH"
    },
    {
        id: 16,
        name:"Panal Cap",
        price:999,
        description:"Many more varients are ab",
        stock:10,
        imageurl:["assets/img/products/cap.jpg"],
        category:"ACCESSORIES"
    },
    {
        id: 4,
        name:"Poco F1",
        price:23999,
        description:" Meet the POCO F1 - the first flagship smartphone from POCO by Xiaomi. The POCO F1 sports Qualcomm flagship Snapdragon 845 processor, an octa-core CPU with a maximum clock speed of 2.8 GHz which is supported by 8 GB of LPDDR4X RAM. ",
        stock:0,
        imageurl:["assets/img/products/pocof1.jpeg","assets/img/products/poco_1.jpeg","assets/img/products/poco_2.jpeg"],
        category:"ELECTRONICS"
    },
    {
        id: 12,
        name:"Galaxy Note 9",
        price:67900,
        description:"Samsung Galaxy Note 8 is an Android Smartphone Designed, Developed and Marketed by Samsung Electronics",
        stock:0,
        imageurl:["assets/img/products/note9_1.jpeg","assets/img/products/note9_2.jpeg","assets/img/products/note9_4.jpeg"],
        category:"ELECTRONICS"
    },
]